(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["scrolling-images"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('willow-scrolling-images')) {
    class WillowScrollingImages extends HTMLElement {
      static observedAttributes = ['data-scroll-speed', 'data-pause-on-hover'];

      connectedCallback() {
        this.viewport = this.querySelector('.scrolling-images__viewport');
        this.track = this.querySelector('.scrolling-images__track');
        this.group = this.querySelector('.scrolling-images__group');
        this.button = this.querySelector('.scrolling-images__toggle');
        if (!this.button || !this.group || this.events) return;

        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.nearby = false;
        this.visible = false;
        this.hovered = false;
        this.selected = false;
        this.userPaused = false;
        this.pendingImages = new Set();
        this.decodedImages = new WeakSet();
        this.imageObserver = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            const image = entry.target;
            if (entry.isIntersecting && !this.decodedImages.has(image)) {
              const pending = this.pendingImages;
              pending.add(image);
              image.loading = 'eager';
              image.decode().catch(() => {
                // A failed photo must not leave the entire gallery paused.
              }).then(() => {
                if (pending !== this.pendingImages || !this.events) return;
                this.decodedImages.add(image);
                pending.delete(image);
                this.updatePlayback();
              });
            } else if (!entry.isIntersecting) {
              this.pendingImages.delete(image);
            }
          }
          this.checkingImages = false;
          this.updatePlayback();
        }, { root: this.viewport, rootMargin: '0px 200px' });
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePlayback();
        }, options);
        this.addEventListener('pointerenter', (event) => {
          this.hovered = event.pointerType === 'mouse';
          this.updatePlayback();
        }, options);
        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.updatePlayback();
        }, options);
        this.addEventListener('shopify:block:select', () => {
          this.selected = true;
          this.updatePlayback();
        }, options);
        this.addEventListener('shopify:block:deselect', () => {
          this.selected = false;
          this.updatePlayback();
        }, options);
        document.addEventListener('visibilitychange', () => this.updatePlayback(), options);
        this.motion.addEventListener('change', () => this.refresh(), options);

        this.resizeObserver = new ResizeObserver(() => this.scheduleRefresh());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        this.nearObserver = new IntersectionObserver(([entry]) => {
          this.nearby = entry.isIntersecting;
          if (this.nearby) this.refresh();
        }, { rootMargin: '200px 0px' });
        this.nearObserver.observe(this);
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.updatePlayback();
        });
        this.visibilityObserver.observe(this);
      }

      attributeChangedCallback() {
        if (this.events) this.refresh();
      }

      scheduleRefresh() {
        if (this.resizeFrame) return;
        this.resizeFrame = requestAnimationFrame(() => {
          this.resizeFrame = null;
          this.refresh();
        });
      }

      refresh() {
        // Existing settings express seconds per 100px, not pixels per second.
        const setting = Number(this.dataset.scrollSpeed);
        if (!Number.isFinite(setting) || setting <= 0 || this.motion.matches) {
          this.resetAnimation();
          return;
        }
        if (!this.nearby) return;

        const distance = this.group.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        if (distance <= 0 || viewportWidth <= 0) {
          this.resetAnimation();
          return;
        }
        // One extra group covers the viewport at the end of every iteration,
        // including a single-image gallery on a wide screen.
        const copies = Math.ceil(viewportWidth / distance);
        const duration = distance * setting * 10;
        if (this.distance === distance && this.duration === duration && this.copies === copies && this.animation) {
          this.updatePlayback();
          return;
        }

        const progress = this.animation ? (Number(this.animation.currentTime) % this.duration) / this.duration : 0;
        this.resetAnimation();
        this.distance = distance;
        this.duration = duration;
        this.copies = copies;
        const fragment = document.createDocumentFragment();
        for (let index = 0; index < copies; index += 1) {
          const copy = this.group.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.querySelectorAll('img').forEach((image) => {
            image.alt = '';
            image.loading = 'lazy';
          });
          fragment.append(copy);
        }
        this.track.append(fragment);
        this.viewport.scrollLeft = 0;
        this.setAttribute('data-animated', '');
        this.viewport.removeAttribute('tabindex');
        this.button.hidden = false;
        this.animation = this.track.animate([
          { transform: 'translateX(0)' },
          { transform: `translateX(-${distance}px)` }
        ], { duration, iterations: Infinity, easing: 'linear' });
        this.animation.pause();
        this.animation.currentTime = progress * duration;
        // Buffer upcoming photos without eagerly downloading the whole strip.
        // Hold position while a buffered image loads rather than moving into it.
        this.checkingImages = true;
        this.track.querySelectorAll('img').forEach((image) => this.imageObserver.observe(image));
        this.updatePlayback();
      }

      updatePlayback() {
        if (!this.animation) return;
        const paused = this.userPaused || this.selected || !this.visible || document.hidden ||
          this.checkingImages || this.pendingImages.size > 0 ||
          (this.hovered && this.dataset.pauseOnHover === 'true');
        if (paused) this.animation.pause();
        else this.animation.play();
        this.button.textContent = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      }

      resetAnimation() {
        this.imageObserver?.disconnect();
        this.pendingImages = new Set();
        this.decodedImages = new WeakSet();
        this.checkingImages = false;
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[aria-hidden="true"]').forEach((copy) => copy.remove());
        this.removeAttribute('data-animated');
        this.viewport.setAttribute('tabindex', '0');
        this.button.hidden = true;
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.resizeObserver?.disconnect();
        this.nearObserver?.disconnect();
        this.visibilityObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = null;
        if (this.track && this.button) this.resetAnimation();
      }
    }
    customElements.define('willow-scrolling-images', WillowScrollingImages);
  }
  } catch(e) { console.error(e); }
})();

})();
